export default __webpack_public_path__ + "static/media/MainBedroom.ef0b367c.png";